<template>
  <div class="container">
     <div style="height:40px;margin:5px 0">
      <Input search style="width:200px" />
      <Button type="primary" icon="md-add" style="margin-left:10px">新建部门</Button>
     </div>
     <div style="height:calc(100% - 110px);width:100%;position:relative;overflow-y:auto;">
      <Spin fix v-if="loading">
        <BaseLoading />
      </Spin>
      <div class="flex-wrap flex-line align-stretch" style="height:100%;">
        <BaseTree :data="deps" :nodeRenderer="renderNode" style="border:1px solid #33333333;min-width:200px;" @event="handleTreeEvent" />
        <div class="container" style="flex-grow:1;padding:0 20px;">
          <BaseEmpty v-if="!selectedDep.id"></BaseEmpty>
          <template v-else >

            <h3 style="font-size:16px">{{selectedDep.name}}</h3>
            <div class="flex-wrap" style="margin:10px 0">
               <Input search style="width:200px" />
      <Button style="margin-left:10px" v-if="selectedDep.id">修改</Button>
      <Button style="margin-left:10px" v-if="selectedDep.id">删除</Button>
            </div>
            <div style="height:calc(100% - 80px);width:100%;">
              <BaseTable :columns="columns" :data="filteredEmployees" />
            </div>
          </template>
        </div>

      </div>

     </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters('oa', ['deps', 'employees']),
    columns() {
      return [{
        key: 'id',
        type: 'index',
        width: 50,
      }, {
        key: 'realname',
        title: '姓名',
        align: 'left',
        width: 100,
        type: 'text',
      }, {
        key: 'gender',
        title: '姓别',
        align: 'left',
        width: 80,
        type: 'text',
      }, {
        key: 'employee_state',
        title: '员工状态',
        align: 'left',
        width: 100,
        type: 'text',
      }, {
        key: 'phone',
        title: '电话',
        align: 'center',
        width: 120,
        type: 'text',
      }, {
        type: 'text',
        title: '岗位',
        key: 'position',
        align: 'center',
        width: 120,
      }, {
        key: 'tool',
        title: '操作',
        align: 'center',
        type: 'text',
        render: (h, {row})=>{
          const buttons = [];
          buttons.push(h('a', {on: {
            click: ()=>{
              this.hanldeSetManager(row);
            },
          }}, '设为主管'));
          buttons.push(h('a', {on: {
            click: ()=>{
              this.hanldeSetManager(row);
            },
          }}, '设为副主管'));
          buttons.push(h('a', {on: {
            click: ()=>{
              this.handleRemove(row);
            },
          }}, '调整部门'));
          return h('div', {class: 'flex-wrap flex-center split5'}, buttons);
        },
      }];
    },
    filteredEmployees() {
      return this.selectedUsers;
    },
  },
  data() {
    return {
      loading: true,
      selectedDep: {},
      selectedUsers: [],
    };
  },
  mounted() {
    this.loading = true;
    this.$store.dispatch('oa/getEmployees');
    this.$store.dispatch('oa/getDeps').then(()=>{}).finally(()=>{
      this.selectedDep = this.deps[0];
      this.loading = false;
    });
  },
  methods: {
    handleRemove() {

    },
    hanldeSetManager() {

    },
    renderNode(h, node) {
      return h('span', [node.name, ` (${node.users.length})`]);
    },
    handleTreeEvent({type, data}) {
      if (type == 'select') {
        this.selectedDep =data;
        this.selectedUsers = data.users.map((uid)=>this.employees.find((v)=>v.account_id == uid)).filter((v)=>v);
      }
    },
  },
};
</script>

<style lang="less">
.dep-item{
  padding:0 10px;
}
</style>
